export default {
  type: "Feature",
  properties: {
    name: "Баруун-Урт",
    location: [45.86701811966825, 113.82616501989689],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [111.16687774658203, 46.23139052104091],
        [111.2200927734375, 46.32417161725694],
        [111.26129150390625, 46.43217825300941],
        [111.24755859375, 46.49082901981415],
        [111.22558593749999, 46.57585481240773],
        [111.24481201171875, 46.66074749832071],
        [111.29974365234375, 46.73233101286786],
        [111.39038085937499, 46.79253827035979],
        [111.37939453125, 46.854556538855746],
        [111.3848876953125, 46.90899838277448],
        [111.42059326171874, 46.96713374957251],
        [111.434326171875, 47.023333688184934],
        [111.46453857421875, 47.133687832776076],
        [111.54693603515625, 47.253135632244216],
        [111.67053222656249, 47.32951560950956],
        [111.796875, 47.37975438400816],
        [112.06535339355469, 47.31648293428332],
        [112.04887390136719, 47.381614160856806],
        [112.049560546875, 47.49864785970502],
        [112.0770263671875, 47.60986653003798],
        [112.1484375, 47.667237034505156],
        [112.2802734375, 47.711609647845975],
        [112.39562988281249, 47.76148371616669],
        [112.5494384765625, 47.79286140021344],
        [112.68402099609374, 47.79286140021344],
        [112.69363403320312, 47.79378398661931],
        [112.70050048828125, 47.724544549099676],
        [112.74169921875, 47.57652571374621],
        [112.87353515625, 47.60616304386874],
        [112.9669189453125, 47.613569753973955],
        [113.10150146484375, 47.58764167941513],
        [113.17565917968749, 47.55984733956309],
        [113.61785888671875, 47.51349065484327],
        [113.675537109375, 47.5153457091302],
        [113.8128662109375, 47.468949677672484],
        [113.9666748046875, 47.364873807434094],
        [114.071044921875, 47.32393057095941],
        [114.18090820312499, 47.253135632244216],
        [114.4720458984375, 47.12621341795227],
        [114.42398071289062, 47.00086080525212],
        [114.4171142578125, 46.89680070399431],
        [114.43634033203125, 46.825435656353896],
        [114.52285766601562, 46.76714653871027],
        [114.6807861328125, 46.70596917928676],
        [114.89501953124999, 46.49839225859763],
        [115.224609375, 46.54563867035857],
        [115.5596923828125, 46.543749602738565],
        [115.6805419921875, 46.581518465658014],
        [116.19415283203125, 46.592843997427394],
        [116.2847900390625, 46.5739667965278],
        [116.34246826171874, 46.511625395437925],
        [116.54159545898438, 46.23685258143992],
        [116.54228210449219, 46.23732751752229],
        [116.53404235839844, 46.22402775339081],
        [116.44203186035156, 46.14130697521705],
        [116.40907287597656, 46.12608040848373],
        [116.27655029296875, 45.97024259702345],
        [116.25457763671875, 45.93969078234],
        [116.25457763671875, 45.90529985724796],
        [116.23260498046874, 45.87853662114514],
        [116.25457763671875, 45.865150166790585],
        [116.27929687499999, 45.8421944579529],
        [116.27105712890625, 45.817315080406246],
        [116.27929687499999, 45.77135470445036],
        [116.21887207031249, 45.74548533557156],
        [116.21612548828124, 45.723918366334765],
        [116.18385314941406, 45.69323099673824],
        [116.14471435546875, 45.68027970958459],
        [116.13304138183594, 45.68027970958459],
        [116.11038208007811, 45.67308325436826],
        [116.06712341308594, 45.68459713847793],
        [116.03004455566405, 45.67932023569538],
        [116.02523803710938, 45.65484809235974],
        [115.9332275390625, 45.63516665067313],
        [115.88928222656249, 45.58521197809401],
        [115.69152832031251, 45.45435093922207],
        [115.37567138671874, 45.390735154248894],
        [114.95544433593749, 45.37530235052552],
        [114.7412109375, 45.43508099838452],
        [114.5489501953125, 45.38301927899065],
        [114.52423095703124, 45.29034662473615],
        [114.38690185546875, 45.14524196975275],
        [114.19464111328125, 45.04441870436415],
        [114.14245605468749, 44.984227835166486],
        [114.05181884765625, 44.92202896709906],
        [113.90075683593749, 44.914249368747086],
        [113.85955810546875, 44.86949623772188],
        [113.79638671875, 44.85197466334987],
        [113.62884521484375, 44.74673324024678],
        [113.5052490234375, 44.77208668197081],
        [113.13720703125, 44.793530904744074],
        [112.93395996093749, 44.83834308566651],
        [112.84881591796875, 44.84029065139799],
        [112.58514404296875, 44.929807512153914],
        [112.51922607421875, 45.01141864227728],
        [112.41485595703125, 45.07739974122637],
        [112.3736572265625, 45.061881623213026],
        [112.10723876953124, 45.07546020688359],
        [112.06054687499999, 45.09873027414909],
        [111.97265625, 45.086126831109596],
        [111.95343017578125, 45.07303569638012],
        [111.95343017578125, 45.071944633095136],
        [111.939697265625, 45.08758121648526],
        [111.91223144531249, 45.17235628126675],
        [111.91223144531249, 45.21687321093267],
        [111.9232177734375, 45.27681919090837],
        [111.9012451171875, 45.321254361171476],
        [111.80511474609375, 45.41002023463975],
        [111.7529296875, 45.49287107405929],
        [111.68426513671875, 45.533288879467456],
        [111.7144775390625, 45.72727377526009],
        [111.70074462890625, 45.922497984579934],
        [111.61834716796875, 46.06179698466216],
        [111.57989501953125, 46.09418614922648],
        [111.5057373046875, 46.115133713265415],
        [111.36566162109375, 46.17412493440401],
        [111.16653442382812, 46.230203044669985],
        [111.16687774658203, 46.23139052104091],
      ],
    ],
  },
};
